"use strict";

import "./CriticalValueNotifications.css";

import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";

import lang from "vwa/lang";
import Button from "vwa/components/Button";
import ProgressBar from "vwa/components/ProgressBar";
import Toast from "vwa/components/Toast";

import sessionStore from "./../../store/session";
import vehicleStore from "./../../store/vehicles";
import eventDescriptorStore from "./../../store/eventDescriptors";
import dataTypeStore from "./../../store/dataTypes";

import NotificationConfigCard from "./NotificationConfigCard";

import addNotificationConfig from "./../../api/addNotificationConfig";
import updateNotificationConfig from "./../../api/updateNotificationConfig";
import removeNotificationConfig from "./../../api/removeNotificationConfig";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import AddDialog from "./AddDialog";

export default class CriticalValueNotifications extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
		this.initStoreListeners();
	}
	
	initState(){
		this.state = {
			inAddition: false,
			inProgress: false,
			displayButton: true,
			notificationConfigs: null
		}
	}
	
	initStoreListeners(){
		eventDescriptorStore.on("change", eventDescriptors => this.updateCriticalValueNotificationConfigsFromStore());
		sessionStore.on("change", _ => this.updateCriticalValueNotificationConfigsFromStore());
	}
	
	componentDidMount() {
		this.createScrollHandler();
		this.updateCriticalValueNotificationConfigsFromStore();
	}
	
	shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	}
	
	createScrollHandler() {
		
		let lastScrollTop = 0;
		
		this.handleScroll = () => {
			if (this.refs.content.scrollTop <= 30) {
				this.setState({displayButton: true});
			}
			else {
				if (this.refs.content.scrollTop > lastScrollTop)
					this.setState({displayButton: false});
				else
					this.setState({displayButton: true});
			}
			lastScrollTop = this.refs.content.scrollTop;
		};
	}
	
	async updateNotificationConfig(eventDescriptor, notificationConfig){
		this.setState({inProgress: true});
		await updateNotificationConfig(eventDescriptor, notificationConfig);
		this.setState({inProgress: false});
		new Toast(lang.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");
	}
	
	async addNotificationConfig(eventDescriptor, notificationConfig){
		this.setState({inProgress: true});
		if(await addNotificationConfig(eventDescriptor, notificationConfig)){
			this.setState({inAddition: false});
			this.refs.addDialog.clear();
		}
		setTimeout(_ => this.updateCriticalValueNotificationConfigsFromStore());
		this.setState({inProgress: false});
		new Toast(lang.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");
	}
	
	async removeNotificationConfig(eventDescriptorId){
		this.setState({inProgress: true});
		await removeNotificationConfig(eventDescriptorId);
		this.setState({inProgress: false});
		new Toast(lang.YOUR_MODIFICATIONS_WILL_TAKE_EFFECT_WITHIN_ONE_HOUR, "green");
	}
	
	updateCriticalValueNotificationConfigsFromStore(){
		const session = sessionStore.get();
		
		if(!session){
			return null;
		}
		
		const notificationSets = session.user.services.filter(service => service.type == "NotificationSet");
		
		const eventDescriptors = eventDescriptorStore.getAll();
		if(!eventDescriptors){
			return null;
		}
		
		const notificationConfigs = eventDescriptors.filter(
			eventDescriptor => eventDescriptor.type == "CriticalScalarStateDescriptor"
		).map(
			eventDescriptor => {
				const notificationSet = notificationSets.find(e => e.value.descriptor == eventDescriptor._id);
				if(notificationSet){
					return notificationSet.value;
				}
				else{
					return null;
				}
			}
		);
		
		this.setState({notificationConfigs});
	}
	
	isButtonHidden() {
		return !this.state.displayButton || this.state.inProgress;
	}
	
	getNotificationDataTypes() {
		const dataTypes = dataTypeStore.getAll();
		return dataTypes.filter(dataType => 
			(	dataType.representationType == "Integer" || dataType.representationType == "Float")
			 && dataType.name != "MobileNetworkCode"
			 && dataType.name != "SignalStrength"
		);
	}
	
	renderCard(notificationConfig){
		if(notificationConfig){
			return (
				<NotificationConfigCard
					key={notificationConfig.descriptor}
					notificationConfig={notificationConfig}
					onSave={(eventDescriptor, notificationConfig) => this.updateNotificationConfig(eventDescriptor, notificationConfig)}
					vehicles={vehicleStore.getAll()}
					dataTypes={this.getNotificationDataTypes()}
					onRemove={() => this.removeNotificationConfig(notificationConfig.descriptor)}
				/>
			);
		}
		return null;
	}
	
	renderCards(){
		return this.state.notificationConfigs ? this.state.notificationConfigs.map(e => this.renderCard(e)) : null;
	}
	
	render(){
		return(
			<div className="CriticalValueNotifications">
				<Button
					icon="plus"
					className={classnames("Floating", "Red", {"Hidden": this.isButtonHidden()})}
					title={lang.ADD_NOTIFICATION_SETUP}
					onClick={_ => this.setState({inAddition: true})}
				/>
				<ProgressBar
					indeterminate
					shown={this.state.inProgress}
				/>
				<div
					ref="content"
					onScroll={() => this.handleScroll()}
					className={classnames("Content", {"Hidden": this.state.inProgress})}
				>
					{this.renderCards()}
				</div>
				<AddDialog
					ref="addDialog"
					shown={this.state.inAddition && !this.state.inProgress}
					dataTypes={this.getNotificationDataTypes()}
					vehicles={vehicleStore.getAll()}
					onCancel={() => this.setState({inAddition: false})}
					onAdd={(eventDescriptor, notificationConfig) => this.addNotificationConfig(eventDescriptor, notificationConfig)}
				/>
			</div>
		);
	}
	
}

CriticalValueNotifications.propTypes = {

};

CriticalValueNotifications.defaultProps = {
	
};


// WEBPACK FOOTER //
// ./src/view/CriticalValueNotifications/CriticalValueNotifications.jsx